import { render, staticRenderFns } from "./FormTextarea.htm?vue&type=template&id=b8dca06e&"
import script from "./FormTextarea.ts?vue&type=script&lang=js&"
export * from "./FormTextarea.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports